<template>
	<el-card shadow="never" class="aui-card--fill">
		<el-row style="background-color: #F3F4F4;">
			<el-col :xs="24" :md="3" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
				<img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/user-list.png" />
				结算单列表
			</el-col>
			<el-col :xs="24" :md="3" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
				<el-select style="width: 95%;" v-model="jiesuanvalue" placeholder="结算列表" @change="getvalue" clearable>
					<el-option v-for="item in jiesuan" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled"></el-option>
				</el-select>
			</el-col>
		</el-row>
		<div class="mod-plat__platdealapproval}">

			<el-table v-loading="dataListLoading" :data="dataList" @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
				<el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
				<!--  <el-table-column prop="id" label="id" header-align="center" align="center"></el-table-column>-->
				<el-table-column label="序号" type="index" width="50" align="center">
					<template slot-scope="scope">
						<span>{{ (page - 1) * limit + scope.$index + 1 }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="serialNumber" label="交易编号" header-align="center" align="center"></el-table-column>
				<el-table-column prop="payerAccountTitle" label="支付方账户名称" header-align="center" align="center"></el-table-column>
				<el-table-column prop="payerBankAccount" label="支付方银行账号" header-align="center" align="center"></el-table-column>
				<el-table-column prop="createDate" label="业务日期" header-align="center" align="center"></el-table-column>
				<el-table-column prop="businessType" label="业务类型" header-align="center" align="center">
					<template slot-scope="scope">
					  <span v-if="scope.row.businessType === 'cz'">充值</span>
					  <span v-else-if="scope.row.businessType === 'grsk'">个人收款</span>
					  <span v-else>支付</span>
					</template>
				</el-table-column>
				<el-table-column prop="payeeBankName" label="收款方账户名称" header-align="center" align="center"></el-table-column>
				<el-table-column prop="payeeBankAccount" label="收款方银行账号" header-align="center" align="center"></el-table-column>
				<el-table-column prop="amount" label="结算金额(元)" header-align="center" align="center"></el-table-column>
				<el-table-column prop="contractCode" label="关联合同编号" header-align="center" align="center">
					<template slot-scope="scope">
						<el-button style="word-break: break-all;white-space: wrap;" type="text" size="small" @click="infoHandle(scope.row.contractId)">{{scope.row.contractCode}}</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="summary" label="关联任务编号" header-align="center" align="center">
					<template slot-scope="scope">
						<el-button style="word-break: break-all;white-space: wrap;" type="text" size="small" @click="taskinfoHandle(scope.row.taskId)">{{scope.row.taskCode}}</el-button>
					</template>
				</el-table-column>

			</el-table>
			<el-pagination
				background
				:current-page="page"
				:page-sizes="[10, 20, 50, 100]"
				:page-size="limit"
				:total="total"
				layout="total, sizes, prev, pager, next, jumper"
				@size-change="pageSizeChangeHandle"
				@current-change="pageCurrentChangeHandle"
			></el-pagination>
			<!-- 弹窗, 新增 / 修改 -->
			<add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
		</div>
	</el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './platdealapproval-add-or-update'
import { addDynamicRoute } from '@/router'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      options: [
        {
          value: '0',
          label: '未开票'
        },
        {
          value: '1',
          label: '已开票'
        }
      ],
      jiesuan: [
        {
          value: '0',
          label: '企业结算列表'
        },
        {
          value: '1',
          label: '个人结算列表'
        }
      ],
      value: '',
      jiesuanvalue: '个人结算列表',
      mixinViewModuleOptions: {
        getDataListURL: '/sys/account/charge/page',
        getDataListIsPage: true,
        deleteURL: '/sys/plat/deal/approval',
        deleteIsBatch: true,
        exportURL: '/sys/plat/deal/approval/export'
      },
      dataForm: {
        money1: '',
        money2: '',
        dealCode: '',
        dealBody: '',
        status: '',
        startDate: '',
        endDate: ''
      }
    }
  },
  components: {
    AddOrUpdate
  },
  methods: {
    childHandle (id) {
		  // 路由参数
		  const routeParams = {
        routeName: `${this.$route.name}__结算申请`,
        title: `结算申请`,
        path: 'plat/platapply-approval',
        params: {
          id: id
        }
		  }
		  // 动态路由
		  addDynamicRoute(routeParams, this.$router)
    },
    getvalue (e) {
      if (e == 0) {
        this.$router.push({ name: 'plat-platdealapproval' })
      }
    },
    // 查看
    infoHandle (id) {
      // 路由参数
      const routeParams = {
        routeName: `${this.$route.name}__合同详情`,
        title: `合同详情`,
        path: 'plat/platcontract-info',
        params: {
						  id: id
        }
      }
      // 动态路由
      addDynamicRoute(routeParams, this.$router)
    },
    taskinfoHandle (id) {
      console.log(id,'123123')
      const routeParams = {
        routeName: `${this.$route.name}__任务详情`,
        title: `任务详情`,
        path: 'plat/platttask-info',
        params: {
          id: id
        }
      }
      // 动态路由
      addDynamicRoute(routeParams, this.$router)
    }
  }
}
</script>
<style>
	.el-button{
		white-space:normal;
	}
</style>
